import { PayloadAction } from '@reduxjs/toolkit';
import { signUpWorkspaceRequest } from 'core/services/authentication';
import { all, fork, takeLatest } from 'redux-saga/effects';
import { ISignUpWorkspaceResponse } from 'types/domain/onboarding';

/**
 * The workspace now exists on its own subdomain, so sign-up ends by leaving this
 * origin: the sign-in link lands on /new/:token there, which signs the user in and
 * sends them into onboarding.
 */
// eslint-disable-next-line require-yield
function* workspaceCreatedSaga(action: PayloadAction<ISignUpWorkspaceResponse>) {
  const { success, signInURL } = action.payload;

  if (success && signInURL?.length) {
    window.location.replace(signInURL);
  }
}

function* watchWorkspaceRequestFulfilled() {
  yield takeLatest(signUpWorkspaceRequest.fulfilled, workspaceCreatedSaga);
}

export function* signUpSaga() {
  yield all([fork(watchWorkspaceRequestFulfilled)]);
}
